import { applyToAllStates } from '../../../../theme/utils/button.theme.utils';
export var _baseMenuTriggerTheme = {
  baseStyle: {
    container: {
      width: 'fit-content',
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: 'l',
      border: 'surface.default',
      backgroundColor: 'transparent',
      outline: 'transparent solid 2px',
      cursor: 'pointer',
      transition: 'outline-color 0.2s',
      _focusVisible: {
        outlineColor: 'focus.focus',
        outlineOffset: '2px'
      },
      _disabled: {
        cursor: 'not-allowed'
      }
    },
    label: {
      display: 'inline-flex'
    }
  },
  sizes: {
    small: _ref => {
      var {
        hasRightElement
      } = _ref;
      return {
        container: {
          height: '32px',
          paddingLeft: hasRightElement ? 's' : 'xs',
          paddingRight: 'xs',
          _focusVisible: {
            outlineOffset: '4px'
          }
        },
        label: {
          textStyle: 'body4Semi'
        }
      };
    },
    medium: {
      container: {
        height: '40px',
        paddingLeft: 's',
        paddingRight: 's'
      },
      label: {
        textStyle: 'body3Semi'
      }
    },
    large: {
      container: {
        height: '48px',
        paddingLeft: 'm',
        paddingRight: 's'
      },
      label: {
        textStyle: 'body2Semi'
      }
    }
  },
  variants: {
    default: {
      container: {
        border: 'surface.default',
        _hover: {
          backgroundColor: 'neutral.lightest'
        },
        _active: {
          backgroundColor: 'neutral.lighter'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          transition: 'outline-color 0.2s'
        },
        _disabled: applyToAllStates({
          backgroundColor: 'transparent',
          color: 'neutral.light'
        })
      }
    },
    inverted: {
      container: {
        border: 'basic.white',
        color: 'neutral.white',
        outlineColor: 'transparent',
        _hover: {
          backgroundColor: 'rgba(255, 255, 255, 0.15)'
        },
        _active: {
          backgroundColor: 'rgba(255, 255, 255, 0.35)'
        },
        _focusVisible: {
          outlineColor: 'focus.invert',
          outlineOffset: '2px',
          outlineWidth: '2px',
          outlineStyle: 'solid',
          transition: 'outline-color 0.2s'
        },
        _disabled: applyToAllStates({
          opacity: 0.35,
          backgroundColor: 'transparent'
        })
      }
    }
  },
  defaultProps: {
    size: 'medium',
    variant: 'default'
  }
};
//# sourceMappingURL=_BaseTrigger.theme.js.map